import {Injectable, signal} from '@angular/core';
import {IMessage} from '../models/i-message';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private messagesSignal = signal<IMessage[]>([]);
  readonly messages = this.messagesSignal.asReadonly();

  private nextId: number = 1;

  show(text: string, type: 'success' | 'error' | 'warning' | 'info' = 'success') {
    const id = this.nextId++;
    const duration = type === 'error' ? 6000 : 3000;

    const newMessage: IMessage = { id, text, type, duration, isLeaving: false };

    this.messagesSignal.update(msgs => [...msgs, newMessage]);

    setTimeout(() => this.removeWithAnimation(id), duration);
  }

  private removeWithAnimation(id: number) {
    this.messagesSignal.update(msgs =>
      msgs.map(m => m.id === id ? { ...m, isLeaving: true } : m)
    );

    setTimeout(() => {
      this.messagesSignal.update(msgs => msgs.filter(m => m.id !== id));
    }, 300);
  }

  remove(id: number) {
    this.removeWithAnimation(id);
  }

  showInfo(text: string): void {
    this.show(text, 'info');
  }

  showSuccess(text: string): void {
    this.show(text, 'success');
  }

  showWarning(text: string): void {
    this.show(text, 'warning');
  }

  showError(text: string): void {
    this.show(text, 'error');
  }

  handleError(error: any): void {
    const msg: string = typeof error.error === 'string' ? error.error : 'Si è verificato un errore';
    this.showError(msg);
  }
}
